export default {
  isAnotherParticipantAlreadySharing: (state, getters, rootState) =>
    rootState.watchTogether.ongoing.isWatchTogetherActive &&
    rootState.myParticipantId !=
      rootState.watchTogether.ongoing.watchTogetherOwnerParticipantId
};
